import { render } from "./AyudasForm.vue?vue&type=template&id=33a0ee03&scoped=true"
import script from "./AyudasForm.vue?vue&type=script&lang=js"
export * from "./AyudasForm.vue?vue&type=script&lang=js"

import "./AyudasForm.vue?vue&type=style&index=0&id=33a0ee03&scoped=scoped&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a0ee03"]])

export default __exports__